import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import '../../style/Orderbook.css';
import * as firebase from 'firebase';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import GradeIcon from 'material-ui-icons/Grade';
import AttachMoneyIcon from 'material-ui-icons/AttachMoney';
import PlusOneIcon from 'material-ui-icons/PlusOne';
import TrendingUpIcon from 'material-ui-icons/TrendingUp';
import BusinessIcon from 'material-ui-icons/Business';
import AccountBoxIcon from 'material-ui-icons/AccountBox';
import SvgIcon from 'material-ui/SvgIcon';
import { CSSTransition } from 'react-transition-group'

const Fade = ({children, ...props}) => (
  <CSSTransition
    {...props}
    timeout={200}
    classNames="fade"
  >
    {children}
  </CSSTransition>
);


//receives sessionid and uid props from simulationContainer.js

//This component is responsible for displaying
//the stats of the user as well as the market

class TotalStats extends Component {
    constructor(props) {
        console.log("TotalStats constructor", props);
        super(props);
        var mymission = "";
        var missionID = `mission${props.sessionid}`
        if(localStorage) {
          if(!localStorage.getItem(missionID)) {
              if (Math.random() <= .5){
                  mymission = "Sell 500";
              } else {
                  mymission = "Buy 500";
              }
              localStorage.setItem(missionID, mymission);
          } else {
            mymission = localStorage.getItem(missionID);
          }
        }
        this.hasWrittenMission = false;
        this.mymission = mymission;
        console.log(mymission, missionID);
        this.state = {
            AverageBuyPrice: '-',
            AverageSellPrice: '-',
            MarketVWAP: '-',
            Cash: '-',
            ABC: '-',
            LastPrice: '-',
            TotalVol: '-',
            ThisPosition: '-',
            Mission: mymission,
            AveragePos: '-',
            Bid: 1,
            Ask: 41,
            PL: 0
        };
    }

    /**
     * Declares all listeners
     */
    componentDidMount() {
        //console.log("TotalStats componentDidMount");

        this.cashRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("Cash");
        this.statsRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("INTC").child("Stats");
        this.vwapRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("VWAP");
        this.totalvolRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("TotalVolume");
        this.lastpriceRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("CurrentAssetPrice");
        this.bidRef = this.props.db.child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData").child("bid");
        this.askRef = this.props.db.child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData").child("ask");

        this.dealerMarketRef = this.props.db.child("Sessions").child(this.props.sessionid).child("DealerMarket");
        this.dealerPlayerRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Dealers").child(this.props.uid);
        this.dealersRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("INTC").child("Stats");
        /// Grabs user cash value and sets corresponding state
//        LastPrice: (snap.val().CurrentAssetPrice / 100).toFixed(2),
//        TotalVol: snap.val().TotalVolume


if(this.props.dealerMode != true){
        this.cashRef.on('value', snap => {

            if (snap.val() !== null) {
                this.setState({
                    Cash: snap.val()
                });
            }
        });
}else{
  this.dealerPlayerRef.on('value', snap=>{

    let data = snap.val();
    if (!!data){
      this.setState({
        Cash: data.cash,
        PL: data.profit,
        ABC: data.position,//NOTE: this differs from the /users/uid/assets/intc/Shares by units of 50, it's weird and one day we need to know why, instead we sledgehammered
      })
    }
  });
}

        /// Grabs user stat values and sets corresponding states
        if(this.props.dealerMode != true){
            console.log("Test 1 runs")
            this.statsRef.on('value', snap =>{

                if(snap.val()){
                    this.setState({
                        AveragePos: (parseFloat(snap.val().avgPos).toFixed(2)),
                        AverageBuyPrice: (snap.val().BuyVWAP),
                        AverageSellPrice: (snap.val().SellVWAP),
                        ThisPosition: (snap.val().ThisPosition),
                        //Mission: (snap.val().Mission),
                        ABC: (snap.val().Shares)
                    });
                    if (!this.hasWrittenMission){
                      this.hasWrittenMission = true;
                      this.statsRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("INTC").child("Stats").child("Mission").set(this.mymission);
                    }
                } else{
                    this.setState({
                        AverageBuyPrice: '-',
                        AverageSellPrice: '-',
                        ThisPosition: '-',
                        //Mission: '-',
                        ABC: "-"
                    });
                }
            });
        } else{
            this.dealersRef.on('value', snap =>{

              console.log("dealers Ref triggered");
            let data = snap.val();
            if (!!data){
                this.setState({
                    AveragePos: (Math.abs(parseFloat(snap.val().avgPos)).toFixed(2)),
                    //ABC: data.Shares,
                    AverageBuyPrice: data.BuyVWAP,
                    AverageSellPrice: data.SellVWAP,
                    ThisPosition: data.ThisPosition,
                    Mission: data.Mission
                })
            }
        });
    }

        /// Grabs market stats and sets corresponding states
        if (this.props.dealerMode != true){
            this.vwapRef.on('value', snap => {

                if (snap.val()) {
                    this.setState({
                        MarketVWAP: (snap.val()),
                    });
                } else {
                    this.setState({
                        MarketVWAP: '-',
                    });
                }
            });
            this.totalvolRef.on('value', snap => {

                if (snap.val()) {
                    this.setState({
                        TotalVol: snap.val()
                    });
                } else {
                    this.setState({
                      TotalVol: '-'
                    });
                }
            });
            this.bidRef.on('value', snap => {
              if (snap.val()) {
                  this.setState({
                      Bid: snap.val()
                  });
              } else {
                  this.setState({
                      Bid: 1
                  });
              }
            });
            this.askRef.on('value', snap => {
              if (snap.val()) {
                  this.setState({
                      Ask: snap.val()
                  });
              } else {
                  this.setState({
                      Ask: 41
                  });
              }
            });
            this.lastpriceRef.on('value', snap => {

                if (snap.val()) {
                    this.setState({
                        LastPrice: (snap.val() / 100).toFixed(2),
                    });
                } else {
                    this.setState({
                        LastPrice: '-',
                    });
                }
            });
        }else{
            this.dealerMarketRef.on('value', snap => {

                let data = snap.val();
                if (!!data){
                    //update state here
                    this.setState({
                      TotalVol: data.volume,
                      MarketVWAP: parseFloat(data.VWAP).toFixed(4),
                      LastPrice: data.lastPrice
                    })
                }
            })
        }
    }

    formatMoney(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(2);
      }
    }

    componentWillUnmount() {
        // console.log("TotalStats componentWillUnmount");
        if(this.props.dealerMode == true){
            this.statsRef.off();
        }

        this.vwapRef.off();
        this.cashRef.off();
        this.dealerMarketRef.off();
        this.dealerPlayerRef.off();
        this.dealersRef.off();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.ABC !== this.props.ABC){
        this.fadeShares = true;
      } else {
        this.fadeShares = false;
      }
    }
    render() {
        //console.log("TotalStats render");
        return (
            <div className='total-stats-style'>
                <div className={'total-stats-box ' + (this.props.dealerMode == true && Math.abs(parseInt(this.state.ABC)) > 500 ? "overLimit" : "underLimit")}>
                    <div className="total-stats-info">
                        <div className="total-stats-info-box">
                            <svg viewBox="0 0 1000 1000" className="total-stats-svg">
                            <path d={"M91.75 142.86c-17.35 2.86-39.19 14.29-52.25 27.15-13.27 13.47-24.29 35.11-27.35 54.3-2.86 18.17-2.86 532.97 0 551.14 6.74 41.84 39.8 74.91 81.65 81.65 18.37 2.86 794.04 2.86 812.41 0 41.85-6.74 74.91-39.8 81.65-81.65 2.86-18.17 2.86-532.97 0-551.14-6.74-41.85-39.8-74.91-81.65-81.65-16.74-2.66-798.13-2.45-814.46.2zm703.21 72.67c4.49 35.31 15.11 57.77 38.78 81.45 23.27 23.68 42.87 32.66 83.28 38.58l7.55 1.23v326.19l-9.59 1.23c-35.52 4.49-57.77 15.1-81.24 38.78-23.68 23.47-34.29 45.72-38.78 81.04l-1.22 9.8H206.27l-1.23-7.55c-3.47-24.09-6.12-33.88-13.68-49.6-6.74-13.88-11.63-20.62-24.9-33.68-23.68-23.68-46.13-34.29-81.45-38.78l-9.59-1.23V336.77l7.76-1.23c24.7-3.47 33.89-6.12 49.4-13.68 13.68-6.53 20.82-11.84 33.89-24.9 23.88-23.88 32.66-42.87 38.58-83.49l1.23-7.55h587.46l1.22 9.61z M486.32 275.13c-5.92 2.86-10.82 7.35-15.92 15.11l-7.55 11.23-9.39-2.86c-20.62-6.12-36.33-1.84-44.91 12.66-4.08 6.94-4.49 9.8-3.47 22.86l1.23 14.9-10.62 4.69c-28.78 13.47-33.68 36.13-12.66 58.58l9.39 10-5.71 14.08c-6.12 15.72-5.92 22.86 1.02 34.29 5.31 8.78 14.49 13.27 29.8 14.49l12.45 1.02 3.47 12.25c4.29 15.11 9.19 22.46 18.37 26.74 12.04 5.72 21.64 4.29 35.52-4.9l12.25-8.37 12.86 8.37c14.29 9.19 23.88 10.41 35.72 4.9 9.19-4.49 14.08-11.63 18.37-26.94l3.47-12.66h8.37c20.21 0 33.48-8.57 38.17-24.49 2.66-8.98 2.66-9.8-6.53-32.05-2.66-6.33-2.45-6.74 6.74-16.53 21.23-22.66 16.33-45.32-12.45-58.58l-10.41-4.9 1.23-13.88c1.02-12.04.41-15.11-3.68-22.86-7.96-15.31-23.47-20-44.91-13.68l-9.39 2.86-7.55-11.23c-7.76-11.63-19.19-18.98-29.6-18.98-2.86 0-8.98 1.84-13.68 3.88zM216.68 403.32c-2.45.41-5.92 3.06-7.76 5.72-2.86 4.49-2.86 5.51.41 12.25 3.88 8.57 11.63 13.06 22.66 13.47 4.9.2 5.92.61 3.06 1.23-2.45.41-5.92 3.06-7.76 5.71-2.65 4.08-2.65 5.51 0 11.84 5.31 13.06 8.78 13.68 68.79 13.68h53.28l-1.02-7.76c-.41-4.08 0-12.86 1.02-19.19 1.84-10.21 1.63-12.45-2.04-17.35-2.04-3.06-5.1-9.19-6.74-13.47l-2.65-7.55-58.38.2c-32.05.2-60.22.81-62.87 1.22zM660.24 407.41c-.61 3.26-3.67 9.19-6.53 13.68-4.08 6.33-4.7 9.19-3.67 15.31.82 4.08 1.43 12.66 1.22 18.98l-.2 11.84h53.68c58.58 0 60.83-.41 67.36-11.84 4.9-8.37 3.27-15.72-4.08-18.37l-5.71-2.04 6.74-.2c9.8-.2 17.76-5.1 21.64-13.47 3.27-6.74 3.27-7.96.41-12.04-1.63-2.65-5.92-5.31-9.59-6.12-3.47-.61-31.84-1.22-63.08-1.22h-56.75l-1.44 5.49zM249.54 583.97c-13.06 6.33-12.65 38.17.61 44.29 3.67 1.63 72.87 2.25 251.68 2.25 231.88 0 246.99-.21 251.07-3.67 9.59-7.55 9.59-34.09 0-41.85-4.08-3.27-18.99-3.47-251.68-3.27-168.6.01-248.62.82-251.68 2.25zM298.73 681.54c-13.06 5.31-12.66 38.58.41 44.7 3.67 1.63 60.01 2.25 202.08 2.25H698.2l4.9-4.9c9.19-9.19 9.19-30.01 0-39.19l-4.9-4.9-197.59.2c-108.59.01-199.43.82-201.88 1.84z"}/>
                            </svg>
                            <p className="total-stats-label">Credits:</p>
                        </div>
                        <Fade in={!!this.fadeShares}>
                        <p className="total-stats-value">
                            {this.state.ABC}
                        </p>
                        </Fade>
                    </div>
                </div>
                {this.props.dealerMode == true &&
                 <div className='total-stats-box'>
                    <div className='total-stats-info'>
                        <div className="total-stats-info-box">
                        <svg viewBox="0 0 24 24" className="total-stats-svg">
                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                        </svg>
                        <p className="total-stats-label">Position Limit:</p>
                        </div>
                        <p className={'total-stats-value'}> 200 </p>
                    </div>
                </div> // Hardcoded the Sell 200, need to change until we establish Dealer Position Limit
                }
                {this.props.dealerMode == false &&
                <div className="mission total-stats-box">
                <div className="total-stats-info">

                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <p className="total-stats-label">Mission:</p>
                    </div>

                    <p className="total-stats-value">
                    {this.state.Mission}
                    </p>

                </div>
                </div>
                }
                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                    {/* <AttachMoneyIcon/> */}
                    <p className="total-stats-label">Cash:</p>
                    </div>

                    {/* Bottom: Cash Value */}
                    <p className="total-stats-value">
                    {this.state.Cash}
                    </p>

                </div>
                </div>


                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
                    </svg>
                    <p className="total-stats-label">P/L:</p>
                    </div>

                    {/* Bottom: Value */}
                    <p className="total-stats-value">
                    {this.formatMoney(parseFloat(this.state.Cash) + parseFloat(this.state.ABC) * parseFloat(this.state.LastPrice))}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"/>
                    </svg>
                    <p className="total-stats-label">Average Pos:</p>
                    </div>

                    {/* Bottom: Value */}
                    <p className="total-stats-value">
                    {this.state.AveragePos}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"/>
                    </svg>
                    <p className="total-stats-label">Average Buy:</p>
                    </div>

                    <p className="total-stats-value">
                    {this.state.AverageBuyPrice}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"/>
                    </svg>
                    <p className="total-stats-label">Average Sell:</p>
                    </div>

                    <p className="total-stats-value">
                    {this.state.AverageSellPrice}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
                    </svg>
                    <p className="total-stats-label">Market VWAP:</p>
                    </div>

                    {/* Bottom: Value */}
                    <p className="total-stats-value">
                    {this.state.MarketVWAP}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
                    </svg>
                    <p className="total-stats-label">Last Price:</p>
                    </div>

                    {/* Bottom: Value */}
                    <p className="total-stats-value">
                    {this.state.LastPrice}
                    </p>

                </div>
                </div>

                <div className="total-stats-box">
                <div className="total-stats-info">

                    {/* Top Row: Icon + Label */}
                    <div className="total-stats-info-box">
                    <svg className="total-stats-svg" viewBox="0 0 24 24">
                        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
                    </svg>
                    <p className="total-stats-label">Market Vol.:</p>
                    </div>

                    {/* Bottom: Value */}
                    <p className="total-stats-value">
                    {this.state.TotalVol}
                    </p>

                </div>
                </div>

              </div>
        );
    }
}

TotalStats.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default TotalStats;



// WEBPACK FOOTER //
// ./src/components/Orderbook/TotalStats.js